"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _tenantContext = require("./tenant-context");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var withTenantContext = function withTenantContext(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/_react["default"].createElement(_tenantContext.TenantContext.Consumer, null, function (tenant) {
      return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, props, {
        tenant: tenant
      }));
    });
  };
};
var _default = exports["default"] = withTenantContext;